<script setup lang="ts">
import getMeta from "@/classes/getMeta";
import DownloadList from "~/components/download/DownloadList.vue";
import PGHS from "~/data/download/pghs_xrad"
import XDAC from "~/data/download/reports"
import XRAD from "~/data/download/dac"
import {CONTACTS} from "~/configs/contacts";

definePageMeta({
  layout: "default",
  name: "download",
});

useHead(getMeta(
    `XSQUARE`,
    `XSQUARE`,
));

const ITEMS = [ PGHS, XDAC, XRAD ];

useJsonld({
  "@context": "https://schema.org/",
  "@type": "Thing",
  "subjectOf": {
    "@context": "https://schema.org/",
    "@graph": ITEMS.map(item => ({
      "@type": "SoftwareApplication",
      name: item.name,
      applicationCategory: "BusinessApplication",
      operatingSystem: "Linux",
      description: item.description,
      author: "Хи-квадрат",
      downloadUrl: Object.keys(item.buttons).length > 0 ? item.buttons[Object.keys(item.buttons)[0]] : "",
      memoryRequirements: "512mb",
      publisher: {
        "@context": "https://schema.org",
        "@type": "Organization",
        "email": CONTACTS.email,
        "name": "Хи-квадрат",
        "telephone": CONTACTS.phone,
      }
    }))
  }
})
</script>

<template>
  <div class="content-page container download-page">
    <download-list
      :items="ITEMS"
    />
  </div>
</template>

<style lang="scss" scoped>
:deep() {
  .main-page-decore {
    display: none;
  }
}
</style>
